export default __webpack_public_path__ + "static/media/b.51e5702c.wav";